<template>
  <div>
    <pulse-loader
      :loading="loading"
      :color="color"
      :size="size"
      class="vue-loader"
    ></pulse-loader>
    <div class="row">
      <div class="col-lg-12">
        <div class="box">
          <div class="box-header">
            <h4 class="box-title">
              <i class="icofont-chart-bar-graph"></i>
              Série histórica
              <div class="grafico-toggle ml-3">
                <button
                  type="button"
                  class="grafico-toggle-btn"
                  :class="{ active: tipoResultado === 'quadrimestral' }"
                  @click="$emit('changeTipoResultado', 'quadrimestral')"
                >
                  Quadrimestral
                </button>
                <button
                  type="button"
                  class="grafico-toggle-btn"
                  :class="{ active: tipoResultado === 'mensal' }"
                  @click="$emit('changeTipoResultado', 'mensal')"
                  :disabled="!podeAlternarResultado"
                >
                  Mensal
                </button>
              </div>
            </h4>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-lg-12">
                <apexchart
                  type="line"
                  height="350"
                  :options="chartOptions"
                  :series="chartData"
                  ref="chartGraficoResultado"
                ></apexchart>
                <FonteSincronizadorC />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueApexCharts from 'vue-apexcharts'
import utils from '@/mixins/utils'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    equipe: {
      type: [Object, String],
      default: '',
    },
    micro_area: {
      type: String,
      default: '',
    },
    selectedFilterBoasPraticas: {
      type: Object,
      default: () => null,
    },
    tipoResultado: {
      type: String,
      default: 'quadrimestral',
    },
  },
  components: {
    PulseLoader,
    apexchart: VueApexCharts,
  },
  mixins: [utils],
  data() {
    return {
      size: '40px',
      color: '#0D98BB',
      chartData: [],
      chartOptions: {
        chart: {
          height: 300,
          type: 'line',
          zoom: {
            enabled: false,
          },
          animations: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
          width: 2,
        },
        title: {
          text: 'Pessoa hipertensa',
          align: 'center',
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          min: 0,
          max: 100,
        },
        legend: {
          show: true,
          position: 'top',
          horizontalAlign: 'center',
        },
        markers: {
          size: 5,
        },
        colors: ['#008FFB', '#ff9933', '#025e1b'],
      },
      x_axis: [],
      dataChartMunicipio: [],
      dataChartEquipe: [],
      dataChartMicroArea: [],
    }
  },
  mounted() {},
  watch: {
    equipe: {
      handler(newValue, oldValue) {
        // console.log(newValue)
      },
      deep: true,
    },
    micro_area: {
      handler(newValue, oldValue) {
        // console.log(newValue)
      },
      deep: true,
    },
  },
  computed: {
    podeAlternarResultado() {
      return (
        this.selectedFilterBoasPraticas == null ||
        this.selectedFilterBoasPraticas.value == null
      )
    },
  },
  methods: {
    /**
     * Altera o tipo de resultado para mensal somente quando o filtro for "Todas".
     *
     * @returns {void}
     */
    alterarParaMensal() {
      if (!this.podeAlternarResultado) {
        return
      }

      this.$emit('changeTipoResultado', 'mensal')
    },

    /**
     * Faz o parse dos dados para object
     * @param item
     *
     * @returns {Object|String}
     */
    getDados(item) {
      return this.parseObjectJson
        ? this.parseObjectJson(item.dados)
        : JSON.parse(item.dados || '{}')
    },

    /**
     * Retorna o resultado do gráfico
     *
     * @param item
     *
     * @returns {Number}
     */
    getResultadoGrafico(item) {
      const dados = this.getDados(item)

      // const [mes, ano] = item.mes_ano.split('/').map(Number)

      // const ehAntesDeMaio2026 = ano < 2026 || (ano === 2026 && mes <= 4)

      // if (this.tipoResultado === 'mensal') {
      //   return ehAntesDeMaio2026 ? null : dados.resultado
      // }

      // return ehAntesDeMaio2026 ? dados.resultado : dados.resultado_quad

      return dados.resultado
    },

    /**
     * Monta os dados da série histórica do município no gráfico
     *
     * @param {Array} dadosSerieHistorica
     *
     * @returns {void}
     */
    serieHistoricaMunicipio(dadosSerieHistorica) {
      let dataItens = dadosSerieHistorica
      dataItens = dataItens.filter((item) => {
        return (
          item.ibge === this.$store.state.cod_ibge &&
          item.nivel == 1 &&
          item.indicador == 50
        )
      })

      let dataItens12meses = dataItens.slice(Math.max(dataItens.length - 12, 0))
      let array_chart_municipio = []
      let array_xaxis = []
      //carregar eixo x
      for (let i = 0; i < dataItens12meses.length; i++) {
        array_xaxis.push(dataItens12meses[i].mes_ano)
      }
      // carregar dados do município
      for (let i = 0; i < dataItens12meses.length; i++) {
        array_chart_municipio.push(
          this.getResultadoGrafico(dataItens12meses[i])
        )
      }
      this.$refs.chartGraficoResultado.updateOptions({
        xaxis: {
          categories: array_xaxis,
        },
      })
      this.xaxis = array_xaxis
      this.$refs.chartGraficoResultado.updateSeries([
        {
          name: this.$store.state.cidade,
          data: array_chart_municipio,
        },
      ])
      this.dataChartMunicipio = array_chart_municipio
    },

    /**
     * Monta os dados da série histórica da equipe no gráfico
     *
     * @param {Array} dadosSerieHistorica
     * @param {object} equipe
     *
     * @returns {void}
     */
    serieHistoricaEquipe(dadosSerieHistorica, equipe) {
      let array_chart_equipe = []
      for (let i = 0; i < this.xaxis.length; i++) {
        var eixo_x_atual = this.xaxis[i]
        let dataItens = dadosSerieHistorica
        dataItens = dataItens.filter((item) => {
          return (
            item.ine == equipe.ine_esf_eap &&
            item.nivel == 2 &&
            item.indicador == 50
          )
        })

        let dataItens12meses = dataItens.slice(
          Math.max(dataItens.length - 12, 0)
        )
        for (const item of dataItens12meses) {
          var resultado = 0
          if (item.mes_ano == eixo_x_atual) {
            resultado = this.getResultadoGrafico(item)
            break
          } else {
            resultado = null
          }
        }
        array_chart_equipe.push(resultado)
      }
      this.dataChartEquipe = array_chart_equipe
      this.$refs.chartGraficoResultado.updateSeries([
        {
          name: this.$store.state.cidade,
          data: this.dataChartMunicipio,
        },
        {
          name: equipe.no_equipe,
          data: array_chart_equipe,
        },
      ])
    },

    /**
     * Monta os dados da série histórica da microárea no gráfico
     *
     * @param {Array} dadosSerieHistorica
     * @param {object} equipe
     * @param {String} micro_area
     *
     * @returns {void}
     */
    serieHistoricaMicroArea(dadosSerieHistorica, equipe, micro_area) {
      let array_chart_micro_area = []
      for (let i = 0; i < this.xaxis.length; i++) {
        var eixo_x_atual = this.xaxis[i]
        let dataItens = dadosSerieHistorica
        dataItens = dataItens.filter((item) => {
          return (
            item.ine == equipe.ine_esf_eap &&
            item.micro_area == micro_area &&
            item.nivel == 3 &&
            item.indicador == 50
          )
        })

        let dataItens12meses = dataItens.slice(
          Math.max(dataItens.length - 12, 0)
        )
        for (const item of dataItens12meses) {
          var resultado = 0
          if (item.mes_ano == eixo_x_atual) {
            resultado = this.getResultadoGrafico(item)
            break
          } else {
            resultado = null
          }
        }
        array_chart_micro_area.push(resultado)
      }
      this.dataChartMicroArea = array_chart_micro_area
      this.$refs.chartGraficoResultado.updateSeries([
        {
          name: this.$store.state.cidade,
          data: this.dataChartMunicipio,
        },
        {
          name: equipe.no_equipe,
          data: this.dataChartEquipe,
        },
        {
          name: 'MICROÁREA ' + micro_area,
          data: array_chart_micro_area,
        },
      ])
    },
  },
}
</script>

<style lang="scss" src="../../styles.scss" scoped></style>
